import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions, RequestMethod, ResponseContentType } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { Router } from '@angular/router';
@Injectable()
export class RestService {

    constructor(private http: Http, public router: Router) {
        router = this.router;
    }


    get(path: any, headers: any): Promise<any> {

        return this.http
            .get(path, { headers })
            .toPromise()
            .then(this.extractData)
            .catch((err: Error) => {
               // alert('There was an error');
               // this.router.navigate(['/home']);
            });
    }

    private extractData(res: Response) {
        let body = res.json();
        return body || {};
    }
}




// WEBPACK FOOTER //
// D:/a/1/s/Fed/src/app/_services/helper/rest-service.ts